/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TaglineInputs */

const en_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium cannabis seed genetics from one of the world’s oldest seedbanks, now available across Thailand.`)
};

const th_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พันธุกรรมเมล็ดกัญชาคุณภาพสูงจากธนาคารเมล็ดพันธุ์ที่เก่าแก่ที่สุดแห่งหนึ่งของโลก พร้อมจำหน่ายทั่วประเทศไทย`)
};

const ja_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`世界最古級のシードバンクによるプレミアムなカンナビス遺伝子を、タイ全国でお届けします。`)
};

const fr_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génétiques de cannabis premium issues de l’une des plus anciennes banques de graines au monde, désormais disponibles dans toute la Thaïlande.`)
};

const es_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genética de cannabis premium de uno de los bancos de semillas más antiguos del mundo, ahora disponible en toda Tailandia.`)
};

const ru_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиальная генетика конопли от одного из старейших сидбанков мира — теперь доступна по всему Таиланду.`)
};

const zh_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来自世界最悠久种子银行之一的优质大麻种子基因，现已在泰国全境供应。`)
};

const vi_footer_tagline = /** @type {(inputs: Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di truyền hạt giống cần sa cao cấp từ một trong những ngân hàng hạt giống lâu đời nhất thế giới, nay đã có mặt trên toàn Thái Lan.`)
};

/**
* | output |
* | --- |
* | "Premium cannabis seed genetics from one of the world’s oldest seedbanks, now available across Thailand." |
*
* @param {Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const footer_tagline = /** @type {((inputs?: Footer_TaglineInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TaglineInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_footer_tagline(inputs)
	if (locale === "ja") return ja_footer_tagline(inputs)
	if (locale === "fr") return fr_footer_tagline(inputs)
	if (locale === "es") return es_footer_tagline(inputs)
	if (locale === "ru") return ru_footer_tagline(inputs)
	if (locale === "zh") return zh_footer_tagline(inputs)
	if (locale === "vi") return vi_footer_tagline(inputs)
	return en_footer_tagline(inputs)
});